import ResourceEditBlock, { ResourceEditBlockProps } from './ResourceEditBlock';
import withInteractor from './ResourceEditBlock.interactor';
import withPresenter from './ResourceEditBlock.presenter';

export type { ResourceEditBlockProps };
export default withInteractor(withPresenter(ResourceEditBlock));
